import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    padding: theme.spacings.md,
  },
  text: {
    fontSize: theme.fontSizes.xl,
  },
  link: {
    color: theme.colors.link,
  },
  paragraph: {
    marginTop: theme.spacings.md,
  },
  buttons: {
    marginTop: theme.spacings.lg,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
